<template>
  <section v-if="!isAuthenticated">
    <button class="button is-primary is-small" @click="modal = true">
      Register
    </button>

    <b-modal :active.sync="modal">
      <div @keypress.enter="register()" class="modal-card">
        <div class="modal-card-body">
          <h2>Secure Login.</h2>
        </div>
        <div class="modal-card-body">
          <b-field label="Username">
            <b-input icon="account" type="text" v-model="username"/>
          </b-field>
          <b-field label="Email">
            <b-input icon="email" type="email" v-model="email"/>
          </b-field>
          <b-field label="Password">
            <b-input icon="lock" type="password" v-model="password"/>
          </b-field>
        </div>
        <div class="modal-card-foot">
          <button class="button is-primary is-small" @click="register()">Register</button>
          <button class="button is-primary is-small is-right" @click="modal = false">Close</button>
        </div>
      </div>
    </b-modal>
  </section>
</template>

<script>
  import UserService from "@/service/UserService"
  import Notifications from "@/utils/Notifications"
  import { Snackbar } from 'buefy/dist/components/snackbar'
  import BModal from "buefy/src/components/modal/Modal";
  import BField from "buefy/src/components/field/Field";
  import BInput from "buefy/src/components/input/Input";
  import BNotification from "buefy/src/components/notification/Notification";
  import {mapGetters} from 'vuex'

  export default {
    name: "Register",
    components: {BNotification, BInput, BField, BModal},
    data() {
      return {
        modal: false,
        username: null,
        password: null,
        email: null,

      }
    },
    computed:{
      ...mapGetters(['isAuthenticated'])
    },
    methods: {
      register() {
        UserService.registerUser(this.username, this.password, this.email).then(response => {
          Snackbar.open({message:`Account Created!`});
          this.modal = false
        }).catch(error => {
          Snackbar.open({message:`An error has occurred whilst creating your account`, type:"is-danger"});
        })
      },
    }
  }
</script>